const routes = [
    {
        path: "/lms/:courseCode/:semesterId",
        component: () => import("../pages/Index.vue"),
        meta: {
            isAuthenticated: true,
            permission: ""
        }
    },

];

export default routes;
